import {AddressTitle, Salutation} from "@/helpers/constants";
import {ValidationRule} from "@/declarations/ValidationRule";
import ModelUpdate from "@/models/ModelUpdate";
import Address from "@/models/address/Address";
import AddressRules from "@/models/address/AddressRules";

export default class AddressUpdate extends ModelUpdate<Address> {

	public phone!: string | null;
	public emails!: string | null;

	public salutation!: Salutation | null;
	public title!: AddressTitle | null;
	public firstname!: string | null;
	public lastname!: string | null;
	public company!: string | null;
	public address1!: string | null;
	public address2!: string | null;
	public street!: string | null;
	public city!: string | null;
	public zip!: string | null;
	public county!: string | null;
	public state!: string | null;
	public countryCode!: string | null;

	protected initializeWithDetailModelData(detailModel: Address): void {
		this.phone = detailModel.phone;
		this.emails = detailModel.emails;
		this.salutation = detailModel.salutation;
		this.title = detailModel.title;
		this.firstname = detailModel.firstname;
		this.lastname = detailModel.lastname;
		this.company = detailModel.company;
		this.address1 = detailModel.address1;
		this.address2 = detailModel.address2;
		this.street = detailModel.street;
		this.city = detailModel.city;
		this.zip = detailModel.zip;
		this.county = detailModel.county;
		this.state = detailModel.state;
		this.countryCode = detailModel.countryCode;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'salutation':
				return AddressRules.salutationRules;
			case 'title':
				return AddressRules.titleRules;
			case 'emails':
				return AddressRules.emailRules(false);
			case 'emailsRequired':
				return AddressRules.emailRules(true);
			case 'phone':
				return AddressRules.phoneRules(this.countryCode);
			default:
				return [];
		}
	}

}
